import WysiwygEditor from '../common/wysiwyg_editor';

class AngularWysiwygEditor extends WysiwygEditor {
  constructor($element) {
    super($element[ 0 ]);
  }

  $onInit() {
    this.initEditor();
  }

  $onDestroy() {
    this.removeEditor();
  }
}

export default {
  name: 'wysiwygEditor',
  obj: {
    controller: AngularWysiwygEditor,
    templateUrl: 'components/wysiwyg_editor.html',
    bindings: {
      value: '=',
      onSave: '&'
    }
  }
}